import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/pricing/PricingPage.tsx");
